<template>
  <div
    class="bg-primary rounded d-flex align-items-center justify-content-between p-3 mb-3 shadow-lg"
  >
    <div class="d-flex align-items-center">
      <i class="bi bi-bell-fill me-2 text-white"></i>
      <div>
        <strong class="text-white">Novo Dashboard Disponível!</strong>
        <p class="mb-0 text-light small">
          Confira a nova versão mais completa.
        </p>
      </div>
    </div>
    <b-button variant="dark" size="sm" @click="goToNewDashboard">
      Quero conhecer
    </b-button>
  </div>
</template>

<script>
export default {
  methods: {
    goToNewDashboard() {
      localStorage.removeItem("dashboard_version");
      window.location.reload();
    },
  },
};
</script>
